import { THEMES } from "../constants";

const inconsistentColors =
  (klight, kdark) =>
  ({ theme }) =>
    theme.id === THEMES.DARK ? theme[kdark] || kdark : theme[klight] || klight;

export default inconsistentColors;
